<template>
	<div class="app-page">
		<div class="filter form">
			<div class="item" data-size="big">
				<input class="textbox" type="text" :placeholder="localizer.get('PrivateArea.Common.ProcessPage_SearchBox_Placeholder')" @keyup.enter="getAssetList()" v-model="searchText" />
			</div>
			<div class="item" data-cta="multi">
				<div class="cta">
					<button class="button" @click="getAssetList()" data-size="small">{{ localizer.get("PrivateArea.Common.ProcessPage_SearchBox_Button") }}</button>
				</div>
				<div class="cta" v-if="isSearch">
					<button class="button" data-type="link" @click="resetSearch()">
						{{ localizer.get("PrivateArea.Common.ProjectDetail_FilterBox_ResetFilters") }}
					</button>
				</div>
			</div>
		</div>
		<div class="item-list">
			<a v-for="(asset, index) in assets" :key="index" :href="asset.linkUrl" class="item">
				<div class="top">
					<div class="date">{{ asset.dateItem }}</div>
					<div class="codes">
						<span v-if="asset.projectCode" class="code">Ord. {{asset.projectCode}}</span>
						<span class="code">Cod. {{ asset.code }}</span>
					</div>
				</div>
				<div class="title">
					<span class="lable">{{ asset.title }}</span>
				</div>
				<div class="box-image">
					<div v-if="asset.isApproved" class="approved-item">
						<span class="icon fastic-check"></span>{{ localizer.get("PrivateArea.Common.AssetApproved") }}
					</div>
					<img v-if="asset.imageUrl" :src="asset.imageUrl" loading="lazy" width="405" height="303" :alt="asset.title" />
					<div v-else class="placeholder"><div class="content"><span class="icon fastic-image"></span></div></div>
				</div>
			</a>
			<div v-if="isSearch && assets.length === 0" class="no-item">{{ localizer.get("PrivateArea.Common.ProjectDetail_NoAssets") }}</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

const store = useStore();
const route = useRoute();
const router = useRouter();
const localizer = Localizer;
const searchText = ref<string | null>(null);
const isLoading = ref(false);
const isSearch = ref(false);
const assets = ref<any[]>([]);

onMounted(async () => {
	if (route.query.searchtext) {
		searchText.value = <string>route.query.searchtext;
		await getAssetList();
	} else if (JSON.parse(window.sessionStorage.getItem("ProcessSearch"))) {
		searchText.value = (JSON.parse(window.sessionStorage.getItem("ProcessSearch"))).searchText;
		if (searchText.value) {
			await getAssetList();
		}
	}
});

async function getAssetList() {
	router.push({ path: window.location.pathname, query: { searchtext: searchText.value } }).catch(() => { });

	isLoading.value = true;
	isSearch.value = true;

	try {
		let response = (await Axios.post((<any>window).App.routes.PrivateArea_Process_GetAssetList, { searchText: searchText.value })).data;
		window.sessionStorage.setItem("ProcessSearch", JSON.stringify({ searchText: searchText.value }));

		assets.value = response;
	} catch (error) {
		if (error.response) {
			if (error.response.status === 400) {
				let validationErrors = FormHelper.getValidationErrors(error.response.data);
				if (validationErrors.length !== 0) {
					store.dispatch("accountAreaToastStore/onAddToast", { message: validationErrors[0].message, type: "Error" });
				}
			}
		}
	}

	isLoading.value = false;
}

function resetSearch() {
	assets.value = [];
	searchText.value = null;
	isSearch.value = false;
}
</script>
